import React, { Component } from 'react'

export default class UserEmptyState extends Component {
  render() {
    return (
      <div className="toolbar-share-user-empty-state">
        You're the only one here!
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/ToolBar/Users/UserEmptyState.js